import { PropTypes } from 'prop-types';
import moment from 'moment-timezone';

var oneOfType = PropTypes.oneOfType,
    arrayOf = PropTypes.arrayOf,
    node = PropTypes.node;


var ReactPropTypeLocationNames = {};

if (process.env.NODE_ENV !== 'production') {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

export var createChainableTypeChecker = function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location) {
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        return new Error('Required ' + locationName + ' \'' + propName + '\' was not specified in \'' + (componentName || 'ANONYMOUS') + '\'');
      }
      return null;
    }

    return validate(props, propName, componentName, location);
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
};

export var childrenPropType = oneOfType([arrayOf(node), node]);

export var routerLocationShape = PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  pathname: PropTypes.string.isRequired,
  search: PropTypes.string
})]);

export var locationShape = routerLocationShape;

export var historyShape = PropTypes.shape({
  push: PropTypes.func.isRequired,
  location: routerLocationShape.isRequired
});

export var stylePropType = PropTypes.oneOfType([PropTypes.object, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.bool]))]);

export var momentPropType = createChainableTypeChecker(function (props, propName, componentName) {
  if (props[propName]) {
    var value = props[propName];
    if (!moment.isMoment(value)) {
      return new Error(propName + ' in ' + (componentName || 'ANNONYMOUS') + ' is not a moment object');
    } else if (!value.isValid()) {
      return new Error(propName + ' in ' + (componentName || 'ANNONYMOUS') + ' is a moment object but it is not valid');
    }
  }

  return null;
});

export var dateType = PropTypes.oneOfType([PropTypes.number, momentPropType]);

export var breadcrumbsShapeList = PropTypes.arrayOf(PropTypes.shape({
  location: locationShape,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}));